
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import AppLazyImage from '~/components/UI/AppLazyImage.vue'
import PageContainer from '~/components/Containers/PageContainer.vue'
import { ContainerOptions } from '~/model'

interface InfoBlock {
  text: string
  images: string[]
  imagesPosition: string
}

@Component({
  components: {
    PageContainer,
    AppLazyImage
  }
})
export default class extends Vue {
  @Prop({
    default: () => {}
  })
  readonly containerOptions!: ContainerOptions

  @Prop({
    default: () => []
  })
  readonly infoBlock!: InfoBlock
}
